const GCInstantVersion = "48.2.0";
export {
  GCInstantVersion as default
};
